export function initEventLogo() {
	const eventLogoContainer = document.getElementById("event-logo-container");
	if (!eventLogoContainer) return;

	const logoUrl = eventLogoContainer.getAttribute("data-logo-url");
	const logoLink = eventLogoContainer.getAttribute("data-logo-link");
	const openInNewWindow =
		eventLogoContainer.getAttribute("data-logo-new-window") !== "false";
	if (!logoUrl || !logoLink) return;

	const newImage = document.createElement("img");
	newImage.src = logoUrl;
	newImage.alt = "";
	newImage.height = 48;

	const newLink = document.createElement("a");
	newLink.href = logoLink;
	if (openInNewWindow) {
		newLink.target = "_blank";
		newLink.rel = "noopener noreferrer";
	}
	newLink.appendChild(newImage);

	const primaryLogo = document.getElementById("itu-primary-logo");
	if (primaryLogo) primaryLogo.before(newLink);
}